// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { Apartamento } from "../../../interfaces/Apartamento";
import { apartamentoByEmpreendimentoService } from "../../../services/apartamentoByEmpreendimentoService";

export const useApartamentoByEmpreendimento = (
  validarEmpreendimento: boolean,
  empreendId: number | undefined
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [aptoByEmpreendimento, setAptoByEmpreendimento] = useState<
    Apartamento[]
  >([]);

  useEffect(() => {
    const fetchBuscarAptoBySystem = async () => {
      if (validarEmpreendimento && empreendId) {
        setIsLoading(true);

        try {
          const data = await apartamentoByEmpreendimentoService(empreendId);
          if (data) {
            setAptoByEmpreendimento(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar apartamento:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchBuscarAptoBySystem();
  }, [validarEmpreendimento, empreendId]); // Dependência
  return { isLoading, aptoByEmpreendimento };
};
